export enum Bucket {
  dev = 'dev',
  prod = 'prod'
}
